import React, { useEffect, useState } from "react";
import HeaderEditMeasurement from "./HeaderEditMeasurement";
import { firestore } from "../firebase";
import { collectIdsAndDocs } from "../utils";
import EditMeasurement from "./EditMeasurement";
import Loader from "./Loader";
import { useSiteProvider } from "../context/SiteProvider";
import { Container, CssBaseline } from "@mui/material";
import {
  useParams,
  matchPath,
  useHistory,
  Link,
  useLocation,
} from "react-router-dom";

function PageEditMeasurement() {
  // const { handle } = useParams();
  const location = useLocation();
  const { props } = location.state;

  const [loading, setLoading] = useState(true);
  // const { sites } = useSiteProvider();

  const [measurement, setMeasurementRef] = useState("");

  const { id: wallId } = useParams();

  const history = useHistory();

  const measurementRef = firestore.doc(
    `sites/${props.siteId}/walls/${props.wallId}/measurements/${props.measurementId}`
  );

  let unsubscribeFromMeasurement = null;

  useEffect(() => {
    unsubscribeFromMeasurement = measurementRef.onSnapshot((snapshot) => {
      const measurement = collectIdsAndDocs(snapshot);
      setMeasurementRef(measurement);
    });

    return () => {
      unsubscribeFromMeasurement();
    };
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  return (
    <Container size="sm">
      <CssBaseline />
      {loading ? (
        <Loader />
      ) : (
        measurement && (
          <>
            <HeaderEditMeasurement
              {...measurement}
              formData={props.formData}
              siteId={props.siteId}
              wallId={props.wallId}
            />
            <EditMeasurement
              {...measurement}
              formData={props.formData}
              siteId={props.siteId}
              wallId={props.wallId}
              measurementId={props.measurementId}
              sideRoom1Name={props.sideRoom1Name}
              sideRoom2Name={props.sideRoom2Name}
              stackedRoom1Name={props.stackedRoom1Name}
              stackedRoom2Name={props.stackedRoom2Name}
            />
            {/* <p>{props.stackedRoom2Name}</p> */}
          </>
        )
      )}

      {/* {sites.map((site) => (
            <EditSite key={site.id} {...site} />
          ))} */}
    </Container>
  );
}

export default PageEditMeasurement;
